import React from "react";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
} from "reactstrap";
import Accordion from "../../../components/AccordionCommon/Accordion";

const SupportPage = () => {
  return (
    <Container className="support-page">
      <Card className="mb-4">
        <CardBody>
          <CardTitle tag="h2">Support</CardTitle>
          <CardText>
            For any inquiries, please reach out to us at
            <a href="mailto:support@ouroffice.io"> support@ouroffice.io</a>.
          </CardText>
        </CardBody>
      </Card>

      <Accordion title={"What is Dani?"}>
        Dani is a tool designed to share and promote diversity, equity, and
        inclusion (DEI) content across your Slack workspace, helping to foster a
        more inclusive work environment.
      </Accordion>
      <Accordion title={"How can i share content?"}>
        You can share content through the culture app by selecting the "Share"
        icon on any post and choosing "Share via Slack" to send it to your
        desired channel.
      </Accordion>
      <Accordion title={"How do I install Dani?"}>
        To install Dani, follow these steps:
        <ol>
          <li>Add your workspace URL and name.</li>
          <li>Click the "Connect Slack" button.</li>
          <li>
            Select your workspace from the dropdown on the Slack install page.
          </li>
          <li>Choose the channel to add Dani to and click "Allow".</li>
        </ol>
      </Accordion>
      <Accordion title={"What should I do after installation?"}>
        After installation, go to the culture app, click the "Share" icon at the
        bottom of any post, select "Share via Slack", and then click the share
        button to share the post via the Dani app.
      </Accordion>
    </Container>
  );
};

export default SupportPage;
